module.exports = __webpack_public_path__ + "static/media/explore.f1a1cedb.svg";